(function () {
  const SELECTORS = {
    root: '[data-tf-cookie]',
    openPreferences: '[data-tf-cookie-open-preferences]',
    close: '[data-tf-cookie-close]',
    acceptAll: '[data-tf-cookie-accept-all]',
    rejectAll: '[data-tf-cookie-reject-all]',
    save: '[data-tf-cookie-save]',
    switch: '[data-tf-cookie-switch]',
  };

  const DEFAULT_PREFS = {
    preferences: false,
    analytics: false,
    marketing: false,
  };
  const STORAGE_KEY = 'topfero_cookie_consent_v1';

  let apiReady = false;
  let root = null;
  let mode = 'banner';
  let prefs = { ...DEFAULT_PREFS };
  let nativeBannerObserver = null;

  const labels = {
    necessary: {
      title: 'Nevyhnutné',
      desc: 'Bez týchto súborov by stránka nefungovala - košík, prihlásenie, jazyk a krajina.',
    },
    preferences: {
      title: 'Predvoľby',
      desc: 'Pamätajú si vaše rozhodnutia ako jazyk, mena a obľúbené produkty.',
    },
    analytics: {
      title: 'Analytika',
      desc: 'Pomáhajú nám pochopiť, ktoré stránky sú obľúbené a kde sa zákazníci strácajú.',
    },
    marketing: {
      title: 'Marketing',
      desc: 'Umožňujú zobrazovať relevantné reklamy na Facebooku, Google a Pinterest.',
    },
  };

  function getConfig() {
    return window.TopferoCookies || {};
  }

  function t(key, fallback) {
    return (getConfig().strings && getConfig().strings[key]) || fallback;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getStoredDecision() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function storeDecision(nextPrefs) {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          preferences: !!nextPrefs.preferences,
          analytics: !!nextPrefs.analytics,
          marketing: !!nextPrefs.marketing,
          updatedAt: Date.now(),
        })
      );
    } catch (error) {
      // Shopify remains the source of truth; localStorage only suppresses duplicate UI.
    }
  }

  function loadCustomerPrivacy(callback) {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      callback(new Error('Shopify loadFeatures is not available'));
      return;
    }

    if (window.Shopify.customerPrivacy) {
      apiReady = true;
      callback();
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        apiReady = !error && !!window.Shopify.customerPrivacy;
        callback(error);
      }
    );
  }

  function getApi() {
    return apiReady ? window.Shopify.customerPrivacy : null;
  }

  function normalizeConsentValue(value) {
    return value === 'yes' || value === true;
  }

  function getCurrentPrefs() {
    const api = getApi();

    if (!api || typeof api.currentVisitorConsent !== 'function') {
      return { ...DEFAULT_PREFS };
    }

    const current = api.currentVisitorConsent() || {};

    return {
      preferences: normalizeConsentValue(current.preferences),
      analytics: normalizeConsentValue(current.analytics),
      marketing: normalizeConsentValue(current.marketing),
    };
  }

  function hasShopifyDecision() {
    const api = getApi();

    if (!api || typeof api.currentVisitorConsent !== 'function') {
      return false;
    }

    const current = api.currentVisitorConsent() || {};
    return ['preferences', 'analytics', 'marketing'].some((key) => current[key] === 'yes' || current[key] === 'no');
  }

  function shouldShowBanner() {
    const api = getApi();

    if (hasShopifyDecision() || getStoredDecision()) {
      return false;
    }

    if (!api || typeof api.shouldShowBanner !== 'function') {
      return false;
    }

    return api.shouldShowBanner();
  }

  function getNativeCookieBanner() {
    const candidates = Array.from(
      document.querySelectorAll(
        '#shopify-pc__banner, [id^="shopify-pc__"], [class*="shopify-pc__"], .shopify-privacy-banner, privacy-banner, [role="dialog"], [role="alertdialog"]'
      )
    );

    return candidates.find((element) => {
      if (!element || element.closest(SELECTORS.root)) return false;

      const text = (element.textContent || '').toLowerCase();
      const looksLikeCookieBanner =
        text.includes('cookie consent') ||
        text.includes('cookie preferences') ||
        text.includes('cookies') ||
        text.includes('súborov cookie') ||
        text.includes('predvoľby cookies');

      if (!looksLikeCookieBanner) return false;

      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  }

  function nativeBannerVisible() {
    return !!getNativeCookieBanner();
  }

  function templateBanner() {
    const privacyUrl = escapeHtml(getConfig().privacyPolicyUrl || '/policies/privacy-policy');

    return `
      <div class="tf-cookie__overlay" aria-hidden="true"></div>
      <section class="tf-cookie__banner" role="dialog" aria-modal="true" aria-labelledby="tf-cookie-title">
        <div class="tf-cookie__banner-inner">
          <span class="tf-cookie__icon" aria-hidden="true">🍪</span>
          <div>
            <h2 class="tf-cookie__title" id="tf-cookie-title">${escapeHtml(
              t('bannerTitle', 'Súhlas s používaním súborov cookie')
            )}</h2>
            <p class="tf-cookie__text">
              ${escapeHtml(
                t(
                  'bannerText',
                  'My a naši partneri vrátane Shopify používame súbory cookie a ďalšie technológie na prispôsobenie vášho zážitku, zobrazovanie reklám a vykonávanie analytických procesov. Tieto účely použijeme iba tam, kde je to povolené alebo s tým súhlasíte.'
                )
              )}
              <a href="${privacyUrl}">${escapeHtml(t('privacyPolicy', 'Zásady ochrany osobných údajov'))}</a>
            </p>
          </div>
          <div class="tf-cookie__actions">
            <button type="button" class="tf-cookie__button tf-cookie__button--ghost" data-tf-cookie-open-preferences>
              ${escapeHtml(t('managePreferences', 'Spravovať predvoľby'))}
            </button>
            <button type="button" class="tf-cookie__button tf-cookie__button--outline" data-tf-cookie-reject-all>
              ${escapeHtml(t('reject', 'Odmietnuť'))}
            </button>
            <button type="button" class="tf-cookie__button tf-cookie__button--accent" data-tf-cookie-accept-all>
              ${escapeHtml(t('accept', 'Prijať'))}
              <span aria-hidden="true">&rarr;</span>
            </button>
          </div>
        </div>
      </section>
    `;
  }

  function templateSwitch(name, value, disabled) {
    return `
      <button
        type="button"
        class="tf-cookie__switch"
        role="switch"
        aria-checked="${value ? 'true' : 'false'}"
        data-tf-cookie-switch="${name}"
        ${disabled ? 'disabled' : ''}
      >
        <span class="tf-cookie__switch-knob" aria-hidden="true"></span>
      </button>
    `;
  }

  function templatePref(name, value, disabled) {
    const item = {
      title: t(`${name}Title`, labels[name].title),
      desc: t(`${name}Desc`, labels[name].desc),
    };

    return `
      <div class="tf-cookie__pref">
        <div class="tf-cookie__pref-main">
          <div class="tf-cookie__pref-title-row">
            <span class="tf-cookie__pref-title">${escapeHtml(item.title)}</span>
            ${disabled ? `<span class="tf-cookie__badge">${escapeHtml(t('alwaysActive', 'Vždy aktívne'))}</span>` : ''}
          </div>
          <p class="tf-cookie__pref-desc">${escapeHtml(item.desc)}</p>
        </div>
        ${templateSwitch(name, value, disabled)}
      </div>
    `;
  }

  function templateModal() {
    return `
      <div class="tf-cookie__overlay" aria-hidden="true"></div>
      <section class="tf-cookie__modal" role="dialog" aria-modal="true" aria-labelledby="tf-cookie-modal-title">
        <div class="tf-cookie__modal-header">
          <span class="tf-cookie__icon tf-cookie__modal-icon" aria-hidden="true">🍪</span>
          <div>
            <h2 class="tf-cookie__modal-title" id="tf-cookie-modal-title">${escapeHtml(
              t('modalTitle', 'Predvoľby cookies')
            )}</h2>
            <p class="tf-cookie__modal-subtitle">${escapeHtml(
              t('modalSubtitle', 'Vyberte si, čo môžeme zbierať. Môžete to kedykoľvek zmeniť.')
            )}</p>
          </div>
          <button type="button" class="tf-cookie__modal-close" data-tf-cookie-close aria-label="${escapeHtml(
            t('close', 'Zavrieť')
          )}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M6 6l12 12M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <div class="tf-cookie__prefs">
          ${templatePref('necessary', true, true)}
          ${templatePref('preferences', prefs.preferences, false)}
          ${templatePref('analytics', prefs.analytics, false)}
          ${templatePref('marketing', prefs.marketing, false)}
        </div>

        <div class="tf-cookie__modal-footer">
          <button type="button" class="tf-cookie__button tf-cookie__button--ghost" data-tf-cookie-reject-all>
            ${escapeHtml(t('rejectAll', 'Odmietnuť všetko'))}
          </button>
          <span class="tf-cookie__modal-footer-spacer" aria-hidden="true"></span>
          <button type="button" class="tf-cookie__button tf-cookie__button--outline" data-tf-cookie-save>
            ${escapeHtml(t('saveSelection', 'Uložiť výber'))}
          </button>
          <button type="button" class="tf-cookie__button tf-cookie__button--accent" data-tf-cookie-accept-all>
            ${escapeHtml(t('acceptAll', 'Prijať všetko'))}
          </button>
        </div>
      </section>
    `;
  }

  function ensureRoot() {
    root = document.querySelector(SELECTORS.root);

    if (!root) {
      root = document.createElement('div');
      root.className = 'tf-cookie';
      root.setAttribute('data-tf-cookie', '');
      root.hidden = true;
      document.body.appendChild(root);
    }

    return root;
  }

  function render(nextMode) {
    mode = nextMode;
    ensureRoot();
    document.body.classList.add('tf-cookie-custom-ready');
    root.hidden = false;
    root.innerHTML = mode === 'modal' ? templateModal() : templateBanner();

    const firstButton = root.querySelector('button:not([disabled])');
    if (mode === 'modal' && firstButton) firstButton.focus({ preventScroll: true });
  }

  function hide() {
    if (!root) return;
    if (hasShopifyDecision() || getStoredDecision()) {
      document.body.classList.add('tf-cookie-custom-ready');
    } else {
      document.body.classList.remove('tf-cookie-custom-ready');
    }
    root.hidden = true;
    root.innerHTML = '';
  }

  function setConsent(nextPrefs) {
    const api = getApi();
    const consent = {
      preferences: !!nextPrefs.preferences,
      analytics: !!nextPrefs.analytics,
      marketing: !!nextPrefs.marketing,
    };

    prefs = { ...consent };
    storeDecision(consent);

    if (!api || typeof api.setTrackingConsent !== 'function') {
      hide();
      return;
    }

    api.setTrackingConsent(consent, hide);
  }

  function showBannerIfNeeded() {
    if (hasShopifyDecision() || getStoredDecision()) {
      hide();
      return;
    }

    if (root && !root.hidden) {
      return;
    }

    if (shouldShowBanner() || nativeBannerVisible()) {
      render('banner');
    }
  }

  function watchNativeBanner() {
    if (nativeBannerObserver) return;

    nativeBannerObserver = new MutationObserver(() => {
      if (!root || root.hidden) {
        showBannerIfNeeded();
      }
    });

    nativeBannerObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(showBannerIfNeeded, 250);
    window.setTimeout(showBannerIfNeeded, 1000);
    window.setTimeout(showBannerIfNeeded, 2500);
  }

  function openPreferences() {
    prefs = getCurrentPrefs();
    render('modal');
  }

  function handleClick(event) {
    const preferencesButton = event.target.closest(SELECTORS.openPreferences);
    const acceptButton = event.target.closest(SELECTORS.acceptAll);
    const rejectButton = event.target.closest(SELECTORS.rejectAll);
    const saveButton = event.target.closest(SELECTORS.save);
    const closeButton = event.target.closest(SELECTORS.close);
    const switchButton = event.target.closest(SELECTORS.switch);

    if (preferencesButton) {
      openPreferences();
      return;
    }

    if (acceptButton) {
      setConsent({ preferences: true, analytics: true, marketing: true });
      return;
    }

    if (rejectButton) {
      setConsent({ ...DEFAULT_PREFS });
      return;
    }

    if (saveButton) {
      setConsent(prefs);
      return;
    }

    if (closeButton) {
      if (shouldShowBanner()) {
        render('banner');
      } else {
        hide();
      }
      return;
    }

    if (switchButton && !switchButton.disabled) {
      const key = switchButton.getAttribute('data-tf-cookie-switch');
      if (!Object.prototype.hasOwnProperty.call(prefs, key)) return;

      prefs = { ...prefs, [key]: !prefs[key] };
      render('modal');
    }
  }

  function handleDocumentClick(event) {
    const target = event.target.closest('a, button');
    if (!target || target.closest(SELECTORS.root)) return;

    const text = (target.textContent || '').trim().toLowerCase();
    const manageLabel = t('managePreferences', 'Spravovať predvoľby').trim().toLowerCase();
    const modalTitle = t('modalTitle', 'Predvoľby cookies').trim().toLowerCase();
    const opensCookies =
      target.matches('[data-tf-cookie-preferences]') ||
      text === 'cookie preferences' ||
      text === 'nastavenia cookies' ||
      text === 'predvoľby cookies' ||
      text === manageLabel ||
      text === modalTitle;

    if (!opensCookies) return;

    event.preventDefault();
    openPreferences();
  }

  function handleKeydown(event) {
    if (event.key === 'Escape' && root && !root.hidden) {
      if (shouldShowBanner()) {
        render('banner');
      } else {
        hide();
      }
    }
  }

  function init() {
    loadCustomerPrivacy((error) => {
      ensureRoot();
      root.addEventListener('click', handleClick);
      document.addEventListener('click', handleDocumentClick);
      document.addEventListener('keydown', handleKeydown);
      window.openCookieSettings = openPreferences;
      window.addEventListener('tf:open-cookies', openPreferences);

      if (error || !apiReady) {
        if (!getStoredDecision()) render('banner');
        return;
      }

      prefs = getCurrentPrefs();
      showBannerIfNeeded();
      watchNativeBanner();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
